export default class Relation {
    constructor(name) {
        this.name = name;
        this.id = Date.now().toString(36) + Math.random().toString(36).substring(2);
    }
}
